if (!customElements.get('size-guide-woman')) {
  class SizeGuideWoman extends window.SizeGuideBase {
    get storageKey () { return 'woman'; }
    get guideType () { return 'woman'; }

    /* Convert bra + cup to chest size (same formula as Gatsby) */
    _convertBraSizeToChestSize (braSize, cupSize) {
        return (braSize % 2 === 0 ? braSize - 4 : braSize - 3) + cupSize * 2;
    }

    updateFormData (element) {
        const field = element?.dataset?.field;
        const value = element?.value;
        this.formData[field] = value;

        if (this.formData.bra !== undefined && this.formData.cup !== undefined && this.formData.height !== undefined) {
            this.computeWomanRecommendation();
        }
    }

    computeWomanRecommendation () {
        const chest = this._convertBraSizeToChestSize(
            Number(this.formData.bra),
            Number(this.formData.cup)
        );

        const recommendation = this.data.find(
            entry =>
                Number(entry.chest) === chest &&
                Number(entry.height) === Number(this.formData.height)
        );

        this._handleRecommendation(recommendation?.size);
    }
  }
 
  customElements.define('size-guide-woman', SizeGuideWoman);
}
